import { __awaiter, __extends, __generator, __read } from "tslib";
import { AsyncEvaluation } from "./Evaluation";
var AsyncOperator = (function () {
    function AsyncOperator() {
    }
    AsyncOperator.prototype.or = function (rule) {
        return new OrOperator(this, rule);
    };
    AsyncOperator.prototype.orNot = function (rule) {
        return new OrOperator(this, rule.notThis());
    };
    AsyncOperator.prototype.xor = function (rule) {
        return new XorOperator(this, rule.notThis());
    };
    AsyncOperator.prototype.and = function (rule) {
        return new AndOperator(this, rule);
    };
    AsyncOperator.prototype.andNot = function (rule) {
        return new AndOperator(this, rule.notThis());
    };
    AsyncOperator.prototype.notThis = function () {
        return new NotOperator(this);
    };
    AsyncOperator.prototype.with = function (ctx) {
        return new WithContextOperator(this, ctx);
    };
    AsyncOperator.prototype.runWith = function (ctx) {
        var _this = this;
        return AsyncEvaluation.evaluateTree(function (evaluation) {
            return _this.evaluate(ctx, evaluation);
        });
    };
    return AsyncOperator;
}());
export { AsyncOperator };
var AnonymousAsyncOperator = (function (_super) {
    __extends(AnonymousAsyncOperator, _super);
    function AnonymousAsyncOperator(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    AnonymousAsyncOperator.prototype.evaluate = function (_, evaluation) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.value()];
            });
        });
    };
    return AnonymousAsyncOperator;
}(AsyncOperator));
export { AnonymousAsyncOperator };
var WithContextOperator = (function (_super) {
    __extends(WithContextOperator, _super);
    function WithContextOperator(value, ctx) {
        var _this = _super.call(this) || this;
        _this.value = value;
        _this.ctx = ctx;
        return _this;
    }
    WithContextOperator.prototype.evaluate = function (_, evaluation) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.value.evaluate(this.ctx, evaluation)];
            });
        });
    };
    return WithContextOperator;
}(AsyncOperator));
export { WithContextOperator };
var OrOperator = (function (_super) {
    __extends(OrOperator, _super);
    function OrOperator(left, right) {
        var _this = _super.call(this) || this;
        _this.left = left;
        _this.right = right;
        return _this;
    }
    OrOperator.prototype.evaluate = function (ctx, evaluation) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.left.evaluate(ctx, evaluation)];
                    case 1:
                        if (_a.sent()) {
                            return [2, true];
                        }
                        return [4, this.right.evaluate(ctx, evaluation)];
                    case 2: return [2, _a.sent()];
                }
            });
        });
    };
    return OrOperator;
}(AsyncOperator));
export { OrOperator };
var XorOperator = (function (_super) {
    __extends(XorOperator, _super);
    function XorOperator(left, right) {
        var _this = _super.call(this) || this;
        _this.left = left;
        _this.right = right;
        return _this;
    }
    XorOperator.prototype.evaluate = function (ctx, evaluation) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, left, right;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, Promise.all([
                            this.left.evaluate(ctx, evaluation),
                            this.right.evaluate(ctx, evaluation)
                        ])];
                    case 1:
                        _a = __read.apply(void 0, [_b.sent(), 2]), left = _a[0], right = _a[1];
                        return [2, left === right];
                }
            });
        });
    };
    return XorOperator;
}(AsyncOperator));
export { XorOperator };
var AndOperator = (function (_super) {
    __extends(AndOperator, _super);
    function AndOperator(left, right) {
        var _this = _super.call(this) || this;
        _this.left = left;
        _this.right = right;
        return _this;
    }
    AndOperator.prototype.evaluate = function (ctx, evaluation) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.left.evaluate(ctx, evaluation)];
                    case 1:
                        if (!_a.sent()) return [3, 3];
                        return [4, this.right.evaluate(ctx, evaluation)];
                    case 2: return [2, _a.sent()];
                    case 3: return [2, false];
                }
            });
        });
    };
    return AndOperator;
}(AsyncOperator));
export { AndOperator };
var NotOperator = (function (_super) {
    __extends(NotOperator, _super);
    function NotOperator(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    NotOperator.prototype.evaluate = function (ctx, evaluation) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.value.evaluate(ctx, evaluation)];
                    case 1: return [2, !(_a.sent())];
                }
            });
        });
    };
    return NotOperator;
}(AsyncOperator));
export { NotOperator };
